import { TableCell, TableHead, TableRow } from "@material-ui/core";
import { REPORT_COLUMNS } from "./constants";

export const HeadColumns = () => (
  <TableHead>
    <TableRow>
      {REPORT_COLUMNS.map(({ id, label }) => (
        <TableCell key={id} align="center">
          {label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);
